import React from 'react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
};
export function SectionCTA({
  label,
  note,
  tone = 'light'
}: SectionCTAProps) {
  return <div className="mx-auto mt-12 max-w-xl" data-id="element-63" data-mp="1lc1p7wp1du28">
      <CTAButton label={label} data-id="element-64" data-mp="1qbxv61hanvkf" />
      {note && <p className={`mt-4 text-center text-sm font-medium ${tone === 'dark' ? 'text-mist' : 'text-muted'}`} data-id="element-65" data-mp="1qamre1numntb">
          {note}
        </p>}
    </div>;
}